import React, { Fragment, useState, useCallback, useEffect } from 'react'
import InputRange from 'react-input-range'
import { Formik, Form, Field } from 'formik'
import { useHistory } from 'react-router-dom'
import Layout from '../../layout/Layout/Layout'
import Loading from 'custom/assets/loaders/Loading'
import AccountsService from '../../services/accounts.service'
import InputError from '../../components/InputError/InputError'
import { SetTargetsSchema } from '../../schemas/other-payments'
import DashboardService from '../../services/dashboard.service'
import NeoInput from '../../components/NeoInput/NeoInput'
import { accountsSelector } from '../../selectors'
import { useSelector, useDispatch } from 'react-redux'
import NeoButton from '../../components/NeoButton/NeoButton'
import NeoOTP from '../../components/FormComponents/NeoOTP'
import NeoSuccess from '../../components/FormComponents/NeoSuccess'
// import { resetCarousel } from '../../actions'
import NumberFormat from 'react-number-format'

const savingList = [
  'Home',
  'Marriage',
  'Celebration',
  'Vacation',
  'Vehicle',
  'Financial',
  'Gadget',
  'Kids and Babies',
  'Other',
]

export default function SetTargets() {
  const dispatch = useDispatch()
  const history = useHistory()
  const [loading, setLoading] = useState(false)
  const [stage, setStage] = useState(0)
  const [accountList, setAccountList] = useState([])
  const [amount, setAmount] = useState()
  const [target, setTarget] = useState(12)
  const [current, setCurrent] = useState({})
  const [formData, setFormData] = useState({})
  const [otpEnable, setOtpEnable] = useState('')
  const [otp, setOtp] = useState('')
  const [successMessage, setSuccessMessage] = useState('')
  const [emiPerMonth, setEmiPerMonth] = useState(amount / target)
  const [randomKey, setRandomKey] = useState('')
  const accounts = useSelector(accountsSelector)

  const fetchAccounts = useCallback(async () => {
    // dispatch(resetCarousel())
    const x = await AccountsService.getAllAccounts()
    setAccountList(x.accountSummaryList)
    setStage(1)
  })

  useEffect(() => {
    fetchAccounts()
    setAmount(100000)
  }, [])

  const handleFormSubmit = useCallback(async (formData) => {
    try {
      formData.tenorMonths = target
      formData.payInAmt = amount
      setFormData(formData)
      const accountDetails = accountList.filter((acc) => acc.accountNo === formData.srcAccNo)[0]
      setCurrent(accountDetails)
      setStage(2)
    } catch (err) {}
  })

  const handleVerify = useCallback(async () => {
    try {
      const response = await DashboardService.rdCreateVerify(formData, current)
      if (response.status === 200) {
        setRandomKey(response.data['randomKey'])
        setOtpEnable(response.data['otpEnable'])
        setStage(3)
      }
    } catch (err) {}
  })

  const handleConfirm = useCallback(async () => {
    try {
      setLoading(true)
      const reqParams = {
        ...formData,
        otpNo: otp,
        randomKey: randomKey,
      }
      const response = await DashboardService.rdCreateConfirm(reqParams, current)
      if (response.status === 200) {
        setStage(4)
        setLoading(false)
      }
    } catch (err) {}
  })

  const otpCallback = useCallback(async (e) => {
    const re = /^[0-9\b]+$/
    if (e.target.value === '' || re.test(e.target.value)) {
      setOtp(e.target.value)
    }
  }, [])

  const handleAmountChange = useCallback(async (value, trgt) => {
    setAmount(value)
    setEmiPerMonth(trgt / target)
  }, [])

  const handleTenderMonthsChange = useCallback(async (value, amt) => {
    setTarget(value)
    setEmiPerMonth(amt / value)
  }, [])

  return (
    <Layout>
      <div className='row d-flex'>
        <NeoButton mode='back' onClick={() => history.goBack()} />
        <div className='mx-3'>
          <h4 className='font-weight-bold'>Set Targets</h4>
          <p className='lead text-secondary'>Description</p>
        </div>
      </div>
      {renderSwitch()}
    </Layout>
  )

  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderLoading()
      case 1:
        return renderForm()
      case 2:
        return renderConfirmation()
      case 3:
        return <NeoOTP loading={loading} otp={otp} setOTP={setOtp} onSubmit={handleConfirm} />
      case 4:
        return <NeoSuccess message={successMessage} linkPath='/dashboard' />
      default:
        return renderLoading()
    }
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }
  function renderForm() {
    return (
      <div>
        <Formik
          initialValues={{
            rdAccDesc: '',
            srcAccNo: '',
            tenorMonths: '',
            payInAmt: '',
          }}
          validationSchema={SetTargetsSchema}
          onSubmit={handleFormSubmit}>
          {({ isSubmitting, errors, touched, handleChange }) => (
            <Form>
              <div className='row'>
                <div className='col-12'>
                  <div className='form-group my-4'>
                    <label className='control-label'>What are you saving for?</label>
                    <NeoInput
                      mode='select'
                      text='What are you saving for?'
                      name='rdAccDesc'
                      onChange={handleChange}
                      list={savingList}
                      keyValue={null}
                    />
                    {/* <Field as='select' className='form-control' name='rdAccDesc'>
                      <option disabled value='' />
                      {savingList.map((item, i) => (
                        <option key={i} value={item}>
                          {item}
                        </option>
                      ))}
                    </Field> */}
                    <InputError text={errors.rdAccDesc} touched={touched.rdAccDesc} />
                  </div>

                  <div className='form-group my-4'>
                    <label className='control-label'>How much do you need?</label>
                    <div style={{ margin: '25px 0' }}>
                      <InputRange
                        name='payInAmt'
                        maxValue={500000}
                        minValue={5000}
                        step={1000}
                        value={amount}
                        onChange={(value) => handleAmountChange(value, target)}
                      />
                    </div>
                  </div>

                  <div className='form-group my-4'>
                    <label className='control-label'>When do you want to reach your goal?</label>
                    <div style={{ margin: '25px 0' }}>
                      <InputRange
                        name='tenorMonths'
                        formatLabel={(value) => `${value}m`}
                        maxValue={24}
                        minValue={1}
                        value={target}
                        onChange={(value) => handleTenderMonthsChange(value, amount)}
                      />
                    </div>
                  </div>

                  <div className='form-group my-4'>
                    <label className='control-label'>EMI per Month :- {amount / target} </label>
                  </div>

                  <div className='form-group my-4'>
                    <NeoInput
                      mode='select'
                      text='Select funding account'
                      name='srcAccNo'
                      onChange={handleChange}
                      list={accounts}
                      keyValue='accountNo'
                    />
                    <InputError text={errors.srcAccNo} touched={touched.srcAccNo} />
                  </div>
                </div>
              </div>
              <div className='mt-5 ml-auto px-0 col-3'>
                <button type='submit' className='btn btn-neo'>
                  Next
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  function renderConfirmation() {
    return (
      <div className='d-flex flex-column'>
        <div className='my-3 d-flex justify-content-between align-items-center'>
          <h6 className='text-gray'>Account Number</h6>
          <h6>{current.accountNo}</h6>
        </div>
        <div className='my-3 d-flex justify-content-between align-items-center'>
          <h6 className='text-gray'>Account Type</h6>
          <h6>{current.accountType}</h6>
        </div>
        <div className='my-3 d-flex justify-content-between align-items-center'>
          <h6 className='text-gray'>Branch Code</h6>
          <h6>{current.brnCode}</h6>
        </div>
        <div className='my-3 d-flex justify-content-between align-items-center'>
          <h6 className='text-gray'>Purpose</h6>
          <h6>{formData.rdAccDesc}</h6>
        </div>

        <div className='my-3 d-flex justify-content-between align-items-center'>
          <h6 className='text-gray'>Tender months</h6>
          <h6>{formData.tenorMonths}</h6>
        </div>
        <div className='my-3 d-flex justify-content-between align-items-center'>
          <h6 className='text-gray'>Tender Amount</h6>
          <h6>
            <NumberFormat
              value={formData.payInAmt}
              displayType={'text'}
              thousandSeparator={true}
              prefix={''}
              fixedDecimalScale={true}
              decimalScale={2}
              allowEmptyFormatting
            />
          </h6>
        </div>
        <div className='my-3 d-flex justify-content-between align-items-center'>
          <h6 className='text-gray'>EMI per Month</h6>
          <h6>{emiPerMonth}</h6>
        </div>
        <div className='mt-5 ml-auto px-0 col-3'>
          {loading ? (
            renderLoading()
          ) : (
            <button type='button' className='btn btn-neo' onClick={() => handleVerify()}>
              Confirm
            </button>
          )}
        </div>
      </div>
    )
  }

  function renderOTP() {
    return (
      <div className='my-4 py-4 d-flex xsflex-column text-center'>
        <div className='row'>
          <div className='col-8 mx-auto'>
            <div className='form-group colored-input'>
              <label className='control-label'>
                Please enter the OTP sent to your registered mobile number
              </label>
              <input
                required
                type='password'
                className='form-control text-center'
                pattern='[0-9]*'
                style={{ fontSize: 24 }}
                maxLength={4}
                value={otp}
                onChange={otpCallback}
              />
            </div>
          </div>
        </div>
        <div className='mt-4 mx-auto px-0 col-3'>
          {loading ? (
            renderLoading()
          ) : (
            <button type='button' className='btn btn-neo' onClick={() => handleConfirm()}>
              Submit
            </button>
          )}
        </div>
      </div>
    )
  }

  function renderSuccess() {
    return (
      <div className='my-5 py-5 d-flex flex-column text-center'>
        {/* <img src={CheckMarkIcon} alt='Success' /> */}
        <p className='mt-4 text-secondary'>{successMessage}</p>
        <div className='mt-4 mx-auto px-0 col-3'>
          <button type='button' className='btn btn-neo' onClick={() => history.push('/dashboard')}>
            Done
          </button>
        </div>
      </div>
    )
  }
}
